import { Component, OnInit } from '@angular/core';
import { IssueService } from '../../issue.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  styleUrls: ['./career.component.css'],
})
export class CareerComponent implements OnInit {
  profileForm: FormGroup;
  constructor(private fb: FormBuilder, private issueservice: IssueService) {}
  ngOnInit(): void {
    this.profileForm = this.fb.group({
      name: '',
      father_name: '',
      place: '',
      dob: '',
      gender: '',
      qualification: '',
      yop: '',
      skills: '',
      email: '',
      phone: '',
      fileupload: '',
    });
  }
  selectedFIle: File = null;
  onselectedfile(event) {
    console.log('file uploaded');
    console.log(event.target.files[0]);
    // const resume = event.target.files[0];
    this.selectedFIle = event.target.files[0];
    // this.profileForm.get('fileupload').setValue(resume);
  }

  onSubmit(
    name,
    father_name,
    place,
    dob,
    gender,
    qualification,
    yop,
    skills,
    email,
    phone
  ) {
    const formData = new FormData();
    // formData.append('name', this.profileForm.get('name').value);
    // formData.append('father_name', this.profileForm.get('father_name').value);
    // formData.append('place', this.profileForm.get('place').value);
    // formData.append('dob', this.profileForm.get('dob').value);
    // formData.append('gender', this.profileForm.get('gender').value);
    // formData.append(
    //   'qualification',
    //   this.profileForm.get('qualification').value
    // );
    // formData.append('yop', this.profileForm.get('yop').value);
    // formData.append('skills', this.profileForm.get('skills').value);
    // formData.append('email', this.profileForm.get('email').value);
    // formData.append('phone', this.profileForm.get('phone').value);

    formData.append('name', name);
    formData.append('father_name', father_name);
    formData.append('place', place);
    formData.append('dob', dob);
    formData.append('gender', gender);
    formData.append('qualification', qualification);
    formData.append('yop', yop);
    formData.append('skills', skills);
    formData.append('email', email);
    formData.append('phone', phone);

    formData.append('fileupload', this.selectedFIle, this.selectedFIle.name);
    console.log(formData.get('fileupload'));
    this.issueservice.addCareerdb(formData);
  }
}
